import { BottomMenuPaths } from "../components/bottom-menu/paths";
import { useBottomMenu } from "./useBottomMenu";

export function useIsTextEditMode() {
	const { currentPath } = useBottomMenu();

	return currentPath === BottomMenuPaths.TextValue;
}
